import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UtilitiesListComponent } from './utilities/utilities-list/utilities-list.component';
import { UtilitiesAddComponent } from './utilities/utilities-add/utilities-add.component';
import { ConfigurationPanelComponent } from './configuration/configuration-panel/configuration-panel.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { BidRoundManagementComponent } from './bid-round-management/bid-round-management.component';
import { AdminComponent } from './test/admin/admin.component';
import { AdminGuard } from 'src/app/shared/guards/admin.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: AdminLoginComponent },

  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { title: 'Dashboard' }
      },
      {
        path: 'utilities',
        children: [
          {
            path: '',
            component: UtilitiesListComponent,
            data: { title: 'Utilities' }
          },
          {
            path: 'add',
            component: UtilitiesAddComponent,
            data: { title: 'Add Utility' }
          }
        ]
      },
      {
        path: 'configuration/:id',
        component: ConfigurationPanelComponent,
        data: { title: 'Utility Configuration' }
      },
      {
        path: 'bid-rounds',
        component: BidRoundManagementComponent,
        data: { title: 'Bid Rounds' }
      },
      {
        path: 'admin-test',
        component: AdminComponent,
        data: { title: 'Admin Test' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminDashRoutingModule { }
